<template>
  <div class="add-company-intro">
    <!-- 语言选择 -->
    <div class="language-selector">
      <template v-if="isDesktop">
        <el-radio-group v-model="currentLang" @change="handleLangChange">
          <el-radio-button v-for="item in languageList" :key="item.code" :label="item.code">{{ item.name }}</el-radio-button>
        </el-radio-group>
      </template>
      <template v-else>
        <van-radio-group v-model="currentLang" @change="handleLangChange" direction="horizontal">
          <van-radio v-for="item in languageList" :key="item.code" :label="item.code">{{ item.name }}</van-radio>
        </van-radio-group>
      </template>
    </div>
    
    <!-- 语言内容输入 -->
    <div class="language-section">
      <rich-text-editor
        v-model="currentData.content"
        :path="'company'"
        :placeholder="placeholders[currentLang]"
        @change="handleContentChange"
      ></rich-text-editor>
    </div>
    
    <!-- 表单操作 -->
    <div class="form-actions">
      <el-button @click="$emit('cancel')">取消</el-button>
      <el-button type="primary" @click="handleSubmit">保存</el-button>
    </div>
  </div>
</template>

<script>

import { getLanguage } from '@/api/public'
import {getCompanyLanguage,updateCompanyInfo} from "@/api/website"
import RichTextEditor from '@/components/tool/RichTextEditor'

export default {
  name: 'AddCompanyIntro',
  components: {
    RichTextEditor
  },
  props: {
    companyIntro: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isDesktop: true,
      languageList: [],
      currentLang: 'zh',
      currentData: {},
      formData: {
        content:"",
      },
      placeholders: {
        zh: '请输入公司简介',
        en: 'Please enter company profile',
        ko: '회사 소개를 입력하세요'
      }
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
    this.getLanguageList()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
  },
  watch: {
    companyIntro: {
      handler(newIntro) {
        if (newIntro) {
          // 重置表单
          this.resetForm()
          // 根据传入的companyIntro的lang属性，更新对应语言的表单数据
          const lang = newIntro.lang || 'zh'
          this.formData[lang] = {
            "content": newIntro.content || ''
          }
        } else {
          this.resetForm()
        }
      },
      immediate: true
    }
  },
  methods: {
    getLanguageId(){
      const item = this.languageList.find(item => item.code === this.currentLang)
      console.log(item)
      return item ? item.id : ''
    },
    getCompanyInfo() {
      // 遍历languageList 当 languageList中code === currentLang 时 赋值lang_id 为 languageList中id
      let lang_id = this.getLanguageId()
      getCompanyLanguage(lang_id).then(res => {
        console.log(res)
        if(res.code === 200){
          this.currentData = res.data || {}
        }
      })
    },
    async getLanguageList() {
      try {
        const response = await getLanguage()
        this.languageList = response.data || []
        this.getCompanyInfo()
      } catch (error) {
        console.error('获取语言列表失败:', error)
      }
    },
    checkScreenSize() {
      this.isDesktop = window.innerWidth > 768
    },
    resetForm() {
      this.formData = {
        content: ''
      }
    },
    addHistoryItem(lang) {
      this.formData[lang].history.push('')
    },
    removeHistoryItem(lang, index) {
      this.formData[lang].history.splice(index, 1)
    },
    addValueItem(lang) {
      this.formData[lang].coreValues.push('')
    },
    removeValueItem(lang, index) {
      this.formData[lang].coreValues.splice(index, 1)
    },

    handleLangChange() {
      // 语言切换时的逻辑
      this.getCompanyInfo()
    },
    handleContentChange(content) {
      // 处理富文本编辑器内容变化
      this.currentData.content = content
    },
    handleSubmit() {
      // 验证表单
      let isValid = true
      if (!isValid) {
        return
      }
      let lang_id = this.getLanguageId()
      updateCompanyInfo(this.currentData.id, {
          "lang_id": lang_id,
          "content": this.currentData.content || ''
      }).then(res => {
        if(res.code === 200){
          this.$emit('save', true)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.add-company-intro {
  box-sizing: border-box;
  padding: 0 20px;
}

.language-selector {
  margin-bottom: 20px;
  text-align: center;
}

/* 语言选择器移动端样式 */
@media (max-width: 768px) {
  .language-selector {
    margin-bottom: 15px;
  }
  
  .language-selector .el-radio-group {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  
  .language-selector .el-radio-button {
    margin-bottom: 5px;
  }
}

.language-section {
  box-sizing: border-box;
  margin-bottom: 30px;
  padding: 20px;
  height: calc(100vh - 254px);
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.language-section h3 {
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 10px;
}

.form-item {
  margin-bottom: 20px;
}

.history-list,
.values-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.history-item,
.value-item {
  display: flex;
  gap: 10px;
  align-items: center;
}

.history-item .el-input,
.value-item .el-input {
  flex: 1;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #f0f2f5;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .add-company-intro {
    padding: 10px 0;
  }
  
  .form-item {
    margin-bottom: 15px;
  }
  
  .history-item,
  .value-item {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .history-item .el-input,
  .value-item .el-input {
    width: 100%;
  }
  
  .form-actions {
    flex-direction: column;
  }
  
  .form-actions .el-button {
    width: 100%;
  }
  
  /* 语言选择器移动端样式 */
  .language-selector .el-radio-group {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  
  .language-selector .el-radio-button {
    margin-bottom: 5px;
  }
  
  /* 富文本编辑器移动端样式 */
  .quill-editor {
    height: 150px;
  }
  
  .ql-toolbar.ql-snow {
    flex-wrap: wrap;
  }
  
  .ql-toolbar.ql-snow .ql-formats {
    margin-right: 10px;
    margin-bottom: 5px;
  }
}


</style>